import { useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { MotorCategoryForm } from "./components/motorCategoryForm";
import { postData } from "../../../services";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const AddMotorCategory = () => {
  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const handleAddMotorCategory = async (categoryData) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p>Are you sure do you want to submit your details.</p>
          <p>
            Category Name:{" "}
            <strong style={{ color: "green", fontWeight: "bold" }}>
              {categoryData.categoryName}
            </strong>
          </p>
          <p style={{ color: "red", marginTop: "10px" }}>
            Please confirm your details, you can't edit it once you click
            confirm.
          </p>
        </div>
      ),
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCircleLoading(true);
        try {
          const categoryPostData = {
            categoryName: categoryData.categoryName,
            code: categoryData?.code,
            parentCategoryId: categoryData?.parentCategoryId?.value,
            description: categoryData.description,
            isActive: categoryData.active,
          };
          const response = await postData(
            "/reference/motor/key-value-category",
            categoryPostData
          );
          const responseMessage = response?.message;
          if (response?.success) {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
            showSnackbar(responseMessage,"success");
            setTimeout(() => {
              navigate("/motor-master/motor-category");
            }, 1000);
          } else {
            showSnackbar(responseMessage,"error");
          }
        } catch (error) {
          setConfirmationDialog({
            ...confirmationDialog,
            open: true,
            title: "Error In Creating Category",
            message:
              `${error?.response?.data?.message}` ||
              "Sorry for your inconvience, there is some issue in our network. Please try again later.",
            showCancel: true,
            showConfirm: false,
            customSection: null,
            onCancel: () => {
              setConfirmationDialog({
                ...confirmationDialog,
                open: false,
              });
            },
          });
        }finally{
          setCircleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/motor-master/motor-category")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Motor Category details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add Motor Category details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorCategoryForm onsubmit={handleAddMotorCategory} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorCategory;
